// Import components
import DeviceLinking from './DeviceLinking';
import CloseButton from '../button/CloseButton';

type Props = {
  isOpen: boolean;
  onClose: () => void;
};

const DeviceLinkingModal = ({ isOpen, onClose }: Props) => {
  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 bg-black/40 flex items-center justify-center z-50 p-2 sm:p-4"
      onClick={onClose}>
      <div
        className="relative bg-white py-6 px-4 w-full max-w-3xl max-h-[calc(100dvh-1rem)] sm:max-h-[90vh] rounded-3xl shadow-xl overflow-y-auto overscroll-y-none hide-scrollbar"
        onClick={(e) => e.stopPropagation()}>
        <CloseButton onClose={onClose} />
        <h2 className="text-xl font-semibold mb-4">Link Devices</h2>
        <div>
          <DeviceLinking />
        </div>
      </div>
    </div>
  );
};

export default DeviceLinkingModal;
